import { UserProfileComponent } from './home/header/user-profile/user-profile.component';
import { AnalisysManagementComponent } from './analisys-management/analisys-management.component';
import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";

// login component
import { LoginComponent } from "./login/login.component";
import { SimulazioneUtenteComponent } from "./login/simulazione-utente/simulazione-utente.component";

// home component
import { HomeComponent } from "./home/home.component";

// loader
import { MappaComponent } from "./mappa/mappa.component";
import { AuthGuardService } from "./servizi/auth-guard.service";
import { DoNotShowSidebarRouteOnRefreshGuard } from "./guard/right-sidebar/do-not-show-sidebar-route-on-refresh.guard";

import ContextProvider from './servizi/contextProvider';

import { IConfigGlobale } from './modelli/config-globale.model';
import configGlobale from 'src/assets/config/config-globale.dev.json';
import { GestioneAnalisiMassivaComponent } from './gestione-analisi-massiva/gestione-analisi-massiva.component';

const conf = configGlobale as IConfigGlobale;

// Fetch context from URL.
// const queryString = window.location.search;
// const urlParams = new URLSearchParams(queryString);
// const contextString = urlParams.get('context')

let queryString = window.location.href;
queryString = queryString.replace("https://", "");
queryString = queryString.replace("http://", "");
const contextString = queryString.split("/")[1]

// Check query params in order to choose namLayout or glLayout: do not use one or the other by default!
var context;
switch (contextString) {
  case "nam":
    context = conf.namLayout;
    break;
  case "gl":
    context = conf.glLayout;
    break;
  default:
    context = conf.glLayout;
    break;
}

// Set global context.
ContextProvider.setContext(context);

const routes: Routes = ContextProvider.getContext().login ? [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "",
    component: HomeComponent,
    runGuardsAndResolvers: "always",

    canActivate: [AuthGuardService], //TEST:commentare per test
    children: [
      {
        path: "mappa",
        component: MappaComponent,
        data: {},
        children: [
          {
            path: "sidebar",
            canActivate: [DoNotShowSidebarRouteOnRefreshGuard],
            loadChildren: () =>
              import("./mappa/right-sidebar/right-sidebar.module").then((m) => m.RightSidebarModule),
          },
        ],
      },
      {
        path: "simulazione-utente",
        component: SimulazioneUtenteComponent,
      },
      {
        path: "gestione-analisi",
        component: AnalisysManagementComponent
      },
      {
        path: "gestione-analisi-massiva",
        component: GestioneAnalisiMassivaComponent
      },
      {
        path: "profile",
        component: UserProfileComponent,
      }
    ],
  },
] : [
  {
    path: "",
    component: HomeComponent,
    runGuardsAndResolvers: "always",

    //canActivate: [AuthGuardService], //TEST:commentare per test
    children: [
      {
        path: "mappa",
        component: MappaComponent,
        data: {},
        children: [
          {
            path: "sidebar",
            canActivate: [DoNotShowSidebarRouteOnRefreshGuard],
            loadChildren: () =>
              import("./mappa/right-sidebar/right-sidebar.module").then((m) => m.RightSidebarModule),
          },
        ],
      }
    ],
  },
];

/** NgModule */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
